import { render, staticRenderFns } from "./editar-tipo-deficiencia.vue?vue&type=template&id=45f3bfbb&"
import script from "./editar-tipo-deficiencia.vue?vue&type=script&lang=ts&"
export * from "./editar-tipo-deficiencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f3bfbb')) {
      api.createRecord('45f3bfbb', component.options)
    } else {
      api.reload('45f3bfbb', component.options)
    }
    module.hot.accept("./editar-tipo-deficiencia.vue?vue&type=template&id=45f3bfbb&", function () {
      api.rerender('45f3bfbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tipo-deficiencia/editar-tipo-deficiencia.vue"
export default component.exports